import { render, staticRenderFns } from "./summary_row.vue?vue&type=template&id=db2d07fa&"
import script from "./summary_row.vue?vue&type=script&lang=js&"
export * from "./summary_row.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports